/**
 * Blueprint for the advanced search history of customers.
 */
export class CustomerSearchHistory {
  public query: string;
  public values: Array<string> | {};
  public basic: boolean;
  public date: Date;

  public constructor(query: string, values: Array<string>, basic: boolean, date: Date) {
    this.query = query;
    this.values = values;
    this.basic = basic;
    this.date = date;
  }
}
